import { useSyncExternalStore } from 'react';
import type { WishSurface } from 'fym-shared/src/analytics/wishTopics';

/**
 * The open wish box, outside React so that any component opens it: the account menu, the mobile
 * account sheet and the empty searches. The app shell (`SMLContainer`) draws the one modal.
 * The app never opens it by itself.
 */
let openFrom: WishSurface | null = null;
const listeners = new Set<() => void>();

function emit(next: WishSurface | null): void {
  openFrom = next;
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot(): WishSurface | null {
  return openFrom;
}

export function openWishBox(from: WishSurface): void {
  emit(from);
}

export function closeWishBox(): void {
  emit(null);
}

/** The surface that opened the wish box, or null while it is closed. */
export function useWishBoxFrom(): WishSurface | null {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
